import { render, staticRenderFns } from "./RelativeRelationTypeDelete.vue?vue&type=template&id=56684eda&"
import script from "./RelativeRelationTypeDelete.vue?vue&type=script&lang=js&"
export * from "./RelativeRelationTypeDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports